import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { SocialWelfareLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const wards = [
  { ward: 1, fileStoreId: "18024926-2a59-4f3c-8a94-891f18042026" },
  { ward: 2, fileStoreId: "18025026-2a59-4f3c-8a94-891f18042026" },
  { ward: 3, fileStoreId: "18025126-2a59-4f3c-8a94-891f18042026" },
  { ward: 4, fileStoreId: "18025226-2a59-4f3c-8a94-891f18042026" },
  { ward: 5, fileStoreId: "18025326-2a59-4f3c-8a94-891f18042026" },
  { ward: 6, fileStoreId: "18025426-2a59-4f3c-8a94-891f18042026" },
  { ward: 7, fileStoreId: "6b6a7a74-b621-4191-adc9-96cb0b611fff" },
  { ward: 8, fileStoreId: "cf2406c4-10f9-4a18-96e2-6e0098e21ed5" },
  { ward: 9, fileStoreId: "711ccd7b-a9a0-47d8-b069-c363c29bf58e" },
  { ward: 10, fileStoreId: "bff8a438-74e9-4ad0-9b09-bb62186f18bf" },
  { ward: 11, fileStoreId: "18025926-2a59-4f3c-8a94-891f18042026" },
  { ward: 12, fileStoreId: "18026026-2a59-4f3c-8a94-891f18042026" },
  { ward: 13, fileStoreId: "18026126-2a59-4f3c-8a94-891f18042026" },
  { ward: 14, fileStoreId: "18026226-2a59-4f3c-8a94-891f18042026" },
  { ward: 15, fileStoreId: "18026326-2a59-4f3c-8a94-891f18042026" },
  { ward: 16, fileStoreId: "18026426-2a59-4f3c-8a94-891f18042026" },
  { ward: 17, fileStoreId: "18026526-2a59-4f3c-8a94-891f18042026" },
  { ward: 18, fileStoreId: "18026626-2a59-4f3c-8a94-891f18042026" },
  { ward: 19, fileStoreId: "18026726-2a59-4f3c-8a94-891f18042026" },
  { ward: 20, fileStoreId: "18026826-2a59-4f3c-8a94-891f18042026" },
  { ward: 21, fileStoreId: "18026926-2a59-4f3c-8a94-891f18042026" },
  { ward: 22, fileStoreId: "18027026-2a59-4f3c-8a94-891f18042026" },
  { ward: 23, fileStoreId: "18027126-2a59-4f3c-8a94-891f18042026" },
  { ward: 24, fileStoreId: "18027226-2a59-4f3c-8a94-891f18042026" },
  { ward: 25, fileStoreId: "5a446770-6275-416b-bac6-c0879b544f6c" },
  { ward: 26, fileStoreId: "18027426-2a59-4f3c-8a94-891f18042026" },
  { ward: 27, fileStoreId: "18027526-2a59-4f3c-8a94-891f18042026" },
  { ward: 28, fileStoreId: "18027626-2a59-4f3c-8a94-891f18042026" },
  { ward: 29, fileStoreId: "18027726-2a59-4f3c-8a94-891f18042026" },
  { ward: 30, fileStoreId: "18027826-2a59-4f3c-8a94-891f18042026" },
  { ward: 31, fileStoreId: "18027926-2a59-4f3c-8a94-891f18042026" },
  { ward: 32, fileStoreId: "18028026-2a59-4f3c-8a94-891f18042026" },
  { ward: 33, fileStoreId: "18028126-2a59-4f3c-8a94-891f18042026" },
  { ward: 34, fileStoreId: "18028226-2a59-4f3c-8a94-891f18042026" },
  { ward: 35, fileStoreId: "18028326-2a59-4f3c-8a94-891f18042026" },
  { ward: 36, fileStoreId: "18028426-2a59-4f3c-8a94-891f18042026" },
  { ward: 37, fileStoreId: "18028526-2a59-4f3c-8a94-891f18042026" },
  { ward: 38, fileStoreId: "18028626-2a59-4f3c-8a94-891f18042026" },
  { ward: 39, fileStoreId: "18028726-2a59-4f3c-8a94-891f18042026" },
  { ward: 40, fileStoreId: "18028826-2a59-4f3c-8a94-891f18042026" },
  { ward: 41, fileStoreId: "18028926-2a59-4f3c-8a94-891f18042026" },
  { ward: 42, fileStoreId: "18029026-2a59-4f3c-8a94-891f18042026" },
  { ward: 43, fileStoreId: "18029126-2a59-4f3c-8a94-891f18042026" },
  { ward: 44, fileStoreId: "18029226-2a59-4f3c-8a94-891f18042026" },
  { ward: 45, fileStoreId: "18029326-2a59-4f3c-8a94-891f18042026" },
  { ward: 46, fileStoreId: "18029426-2a59-4f3c-8a94-891f18042026" },
  { ward: 47, fileStoreId: "18029526-2a59-4f3c-8a94-891f18042026" },
  { ward: 48, fileStoreId: "18029626-2a59-4f3c-8a94-891f18042026" },
  { ward: 49, fileStoreId: "18029726-2a59-4f3c-8a94-891f18042026" },
  { ward: 50, fileStoreId: "18029826-2a59-4f3c-8a94-891f18042026" },
  { ward: 51, fileStoreId: "18029926-2a59-4f3c-8a94-891f18042026" },
  { ward: 52, fileStoreId: "18030026-2a59-4f3c-8a94-891f18042026" },
  { ward: 53, fileStoreId: "18030126-2a59-4f3c-8a94-891f18042026" },
  { ward: 54, fileStoreId: "18030226-2a59-4f3c-8a94-891f18042026" },
  { ward: 55, fileStoreId: "18030326-2a59-4f3c-8a94-891f18042026" },
  { ward: 56, fileStoreId: "18030426-2a59-4f3c-8a94-891f18042026" },
  { ward: 57, fileStoreId: "18030526-2a59-4f3c-8a94-891f18042026" },
  { ward: 58, fileStoreId: "18030626-2a59-4f3c-8a94-891f18042026" },
  { ward: 59, fileStoreId: "18030726-2a59-4f3c-8a94-891f18042026" },
  { ward: 60, fileStoreId: "18030826-2a59-4f3c-8a94-891f18042026" },
  { ward: 61, fileStoreId: "18030926-2a59-4f3c-8a94-891f18042026" },
  { ward: 62, fileStoreId: "18031026-2a59-4f3c-8a94-891f18042026" },
  { ward: 63, fileStoreId: "18031126-2a59-4f3c-8a94-891f18042026" },
  { ward: 64, fileStoreId: "18031226-2a59-4f3c-8a94-891f18042026" },
  { ward: 65, fileStoreId: "18031326-2a59-4f3c-8a94-891f18042026" },
  { ward: 66, fileStoreId: "18031426-2a59-4f3c-8a94-891f18042026" },
  { ward: 67, fileStoreId: "18031526-2a59-4f3c-8a94-891f18042026" },
  { ward: 68, fileStoreId: "18031626-2a59-4f3c-8a94-891f18042026" },
  { ward: 69, fileStoreId: "18031726-2a59-4f3c-8a94-891f18042026" },
  { ward: 70, fileStoreId: "18031826-2a59-4f3c-8a94-891f18042026" },
  { ward: 71, fileStoreId: "18031926-2a59-4f3c-8a94-891f18042026" },
  { ward: 72, fileStoreId: "135a3faa-934c-4e20-ac35-296b8c9a6b95" },
  { ward: 73, fileStoreId: "558831fc-3a9e-4e08-a2d3-9917b2f2538f" },
  { ward: 74, fileStoreId: "817854a0-f370-4d62-9ed9-0be96afa905e" },
  { ward: 75, fileStoreId: "18032326-2a59-4f3c-8a94-891f18042026" },
  { ward: 76, fileStoreId: "18032426-2a59-4f3c-8a94-891f18042026" },
  { ward: 77, fileStoreId: "18032526-2a59-4f3c-8a94-891f18042026" },
  { ward: 78, fileStoreId: "18032626-2a59-4f3c-8a94-891f18042026" },
  { ward: 79, fileStoreId: "18032726-2a59-4f3c-8a94-891f18042026" },
  { ward: 80, fileStoreId: "18032826-2a59-4f3c-8a94-891f18042026" },
  { ward: 81, fileStoreId: "18032926-2a59-4f3c-8a94-891f18042026" },
  { ward: 82, fileStoreId: "18033026-2a59-4f3c-8a94-891f18042026" },
  { ward: 83, fileStoreId: "18033126-2a59-4f3c-8a94-891f18042026" },
  { ward: 84, fileStoreId: "18033226-2a59-4f3c-8a94-891f18042026" },
  { ward: 85, fileStoreId: "18033326-2a59-4f3c-8a94-891f18042026" },
  { ward: 86, fileStoreId: "18033426-2a59-4f3c-8a94-891f18042026" },
  { ward: 87, fileStoreId: "18033526-2a59-4f3c-8a94-891f18042026" },
  { ward: 88, fileStoreId: "18033626-2a59-4f3c-8a94-891f18042026" },
  { ward: 89, fileStoreId: "18033726-2a59-4f3c-8a94-891f18042026" },
  { ward: 90, fileStoreId: "18033826-2a59-4f3c-8a94-891f18042026" },
  { ward: 91, fileStoreId: "18033926-2a59-4f3c-8a94-891f18042026" },
  { ward: 92, fileStoreId: "18034026-2a59-4f3c-8a94-891f18042026" },
  { ward: 93, fileStoreId: "18034126-2a59-4f3c-8a94-891f18042026" },
  { ward: 94, fileStoreId: "18034226-2a59-4f3c-8a94-891f18042026" },
  { ward: 95, fileStoreId: "18034326-2a59-4f3c-8a94-891f18042026" },
  { ward: 96, fileStoreId: "18034426-2a59-4f3c-8a94-891f18042026" },
  { ward: 97, fileStoreId: "18034526-2a59-4f3c-8a94-891f18042026" },
  { ward: 98, fileStoreId: "18034626-2a59-4f3c-8a94-891f18042026" },
  { ward: 99, fileStoreId: "18034726-2a59-4f3c-8a94-891f18042026" },
  { ward: 100, fileStoreId: "18034826-2a59-4f3c-8a94-891f18042026" },
  { ward: 101, fileStoreId: "18034926-2a59-4f3c-8a94-891f18042026" },
  { ward: 102, fileStoreId: "18035026-2a59-4f3c-8a94-891f18042026" },
  { ward: 103, fileStoreId: "18035126-2a59-4f3c-8a94-891f18042026" },
  { ward: 104, fileStoreId: "18035226-2a59-4f3c-8a94-891f18042026" },
  { ward: 105, fileStoreId: "18035326-2a59-4f3c-8a94-891f18042026" },
  { ward: 106, fileStoreId: "18035426-2a59-4f3c-8a94-891f18042026" },
  { ward: 107, fileStoreId: "18035526-2a59-4f3c-8a94-891f18042026" },
  { ward: 108, fileStoreId: "18035626-2a59-4f3c-8a94-891f18042026" },
  { ward: 109, fileStoreId: "18035726-2a59-4f3c-8a94-891f18042026" },
  { ward: 110, fileStoreId: "18035826-2a59-4f3c-8a94-891f18042026" },
  { ward: 111, fileStoreId: "18035926-2a59-4f3c-8a94-891f18042026" },
  { ward: 112, fileStoreId: "18036026-2a59-4f3c-8a94-891f18042026" },
  { ward: 113, fileStoreId: "18036126-2a59-4f3c-8a94-891f18042026" },
  { ward: 114, fileStoreId: "18036226-2a59-4f3c-8a94-891f18042026" },
  { ward: 115, fileStoreId: "18036326-2a59-4f3c-8a94-891f18042026" },
  { ward: 116, fileStoreId: "18036426-2a59-4f3c-8a94-891f18042026" },
  { ward: 117, fileStoreId: "18036526-2a59-4f3c-8a94-891f18042026" },
  { ward: 118, fileStoreId: "18036626-2a59-4f3c-8a94-891f18042026" },
  { ward: 119, fileStoreId: "18036726-2a59-4f3c-8a94-891f18042026" },
  { ward: 120, fileStoreId: "18036826-2a59-4f3c-8a94-891f18042026" },
  { ward: 121, fileStoreId: "18036926-2a59-4f3c-8a94-891f18042026" },
  { ward: 122, fileStoreId: "18037026-2a59-4f3c-8a94-891f18042026" },
  { ward: 123, fileStoreId: "18037126-2a59-4f3c-8a94-891f18042026" },
  { ward: 124, fileStoreId: "18037226-2a59-4f3c-8a94-891f18042026" },
  { ward: 125, fileStoreId: "18037326-2a59-4f3c-8a94-891f18042026" },
  { ward: 126, fileStoreId: "18037426-2a59-4f3c-8a94-891f18042026" },
  { ward: 127, fileStoreId: "18037526-2a59-4f3c-8a94-891f18042026" },
  { ward: 128, fileStoreId: "18037626-2a59-4f3c-8a94-891f18042026" },
  { ward: 129, fileStoreId: "18037726-2a59-4f3c-8a94-891f18042026" },
  { ward: 130, fileStoreId: "18037826-2a59-4f3c-8a94-891f18042026" },
  { ward: 131, fileStoreId: "18037926-2a59-4f3c-8a94-891f18042026" },
  { ward: 132, fileStoreId: "18038026-2a59-4f3c-8a94-891f18042026" },
  { ward: 133, fileStoreId: "18038126-2a59-4f3c-8a94-891f18042026" },
  { ward: 134, fileStoreId: "18038226-2a59-4f3c-8a94-891f18042026" },
  { ward: 135, fileStoreId: "18038326-2a59-4f3c-8a94-891f18042026" },
  { ward: 136, fileStoreId: "18038426-2a59-4f3c-8a94-891f18042026" },
  { ward: 137, fileStoreId: "18038526-2a59-4f3c-8a94-891f18042026" },
  { ward: 138, fileStoreId: "18038626-2a59-4f3c-8a94-891f18042026" },
  { ward: 139, fileStoreId: "18038726-2a59-4f3c-8a94-891f18042026" },
  { ward: 140, fileStoreId: "18038826-2a59-4f3c-8a94-891f18042026" },
  { ward: 141, fileStoreId: "18038926-2a59-4f3c-8a94-891f18042026" },
  { ward: 142, fileStoreId: "18039026-2a59-4f3c-8a94-891f18042026" },
  { ward: 143, fileStoreId: "18039126-2a59-4f3c-8a94-891f18042026" },
  { ward: 144, fileStoreId: "18039226-2a59-4f3c-8a94-891f18042026" },
];

const chunkArray = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const Ward_Wise_BPL_List = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {SocialWelfareLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Ward Wise BPL List :")}
                    </h3>
                  </div>
                  <div className="mayor-table2 depart min-height-400">
                    <table className="table table-bordered">
                        {/* <tbody>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18024926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward - 1")}
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18025026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward - 2")}
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18025126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward - 3 ")}
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18025226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward - 4")}
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18025326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 5
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18025426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 6
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"6b6a7a74-b621-4191-adc9-96cb0b611fff"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 7
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"cf2406c4-10f9-4a18-96e2-6e0098e21ed5"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 8
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"711ccd7b-a9a0-47d8-b069-c363c29bf58e"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 9
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"bff8a438-74e9-4ad0-9b09-bb62186f18bf"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 10
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18025926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 11
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 12
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 13
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 14
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 15
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 16
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 17
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 18
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 19
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 20
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18026926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 21
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 22
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 23
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 24
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"5a446770-6275-416b-bac6-c0879b544f6c"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 25
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 26
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 27
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 28
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 29
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 30
                            </a>
                          </td>

                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18027926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 31
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 32
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 33
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 34
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 35
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 36
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 37
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 38
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 39
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 40
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18028926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 41
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 42
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 43
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 44
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 45
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 46
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 47
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 48
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 49
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 50
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18029926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 51
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 52
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 53
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 54
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 55
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 56
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 57
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 58
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 59
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 60
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18030926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 61
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 62
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 63
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 64
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 65
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 66
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 67
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 68
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 69
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 70
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18031926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 71
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"135a3faa-934c-4e20-ac35-296b8c9a6b95"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 72
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"558831fc-3a9e-4e08-a2d3-9917b2f2538f"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 73
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"817854a0-f370-4d62-9ed9-0be96afa905e"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 74
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18032326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 75
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18032426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 76
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18032526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 77
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18032626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 78
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18032726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 79
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18032826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 80
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18032926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 81
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 82
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 83
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 84
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 85
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 86
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 87
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 88
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 89
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 90
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18033926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 91
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 92
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 93
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 94
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 95
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 96
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 97
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 98
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 99
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 100
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18034926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 101
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 102
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 103
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 104
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 105
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 106
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 107
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 108
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 109
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 110
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18035926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 111
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 112
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 113
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 114
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 115
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 116
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 117
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 118
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 119
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 120
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18036926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 121
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 122
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 123
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 124
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 125
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 126
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 127
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 128
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 129
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 130
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18037926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 131
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 132
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 133
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 134
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 135
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 136
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 137
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 138
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 139
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 140
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td scope="row">
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18038926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 141
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 142
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 143
                            </a>
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              {t("Ward")} - 144
                            </a>
                          </td>
                         
                        </tr>
                      </tbody> */}
                      <tbody>
                        {chunkArray(wards, 4).map((row, rowIdx) => (
                          <tr key={rowIdx}>
                            {row.map(({ ward, fileStoreId }) => (
                              <td key={ward}>
                                <DownloadFileByFileStoreId
                                  fileStoreId={fileStoreId}
                                  label={`Ward - ${ward}`}
                                  classAdd={false}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ward_Wise_BPL_List;
